import { render, staticRenderFns } from "./editorV1.vue?vue&type=template&id=0734d619"
import script from "./editorV1.vue?vue&type=script&lang=js"
export * from "./editorV1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports